import {CanDeactivate} from '@angular/router';
import {Injectable} from '@angular/core';
import {CanDeactivateComponent} from './component/can-deactivate-component';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<CanDeactivateComponent> {
  constructor(private translateService: TranslateService) {
  }

  canDeactivate(component: CanDeactivateComponent): boolean {
    return component != null && !component.canDeactivate() ? confirm(this.translateService.instant(component.canDeactivateMessage)) : true;
  }
}
